import { IGetAllInspecaoMaquinasEquipItemUseCase } from "../../../presentation/useCases/read/get_all_inspecao_maquinas_equip_item_use_case";
import { BasePaginatedUseCase } from "../../../../../common/domain/useCases/base_paginated_use_case";
import { IControlePatrimonioRepository } from "../../repositories/ControledePatrimonio";
import { InspecaoMaquinaEquipItemLista } from "../../models/inspecao_maquina_equip_item_lista";

/**
 * GetAllInspecaoMaquinasEquipItemUseCase
 */

export class GetAllInspecaoMaquinasEquipItemUseCase
  extends BasePaginatedUseCase<InspecaoMaquinaEquipItemLista>
  implements IGetAllInspecaoMaquinasEquipItemUseCase {
  constructor(private readonly repository: IControlePatrimonioRepository) {
    super();
  }

  async getAllInspecaoMaquinasEquipItem(
    idControleCentroCusto: number | undefined,
    idInspecaoMaquinaEquip: number | undefined,
    page: number,
    rowsPerPage: number,
  ): Promise<void> {
    if (idControleCentroCusto === undefined) throw new Error("Falha ao obter id do controle de centro de custo!");
    if (idInspecaoMaquinaEquip === undefined) throw new Error("Falha ao obter id da inspeção da máquina/equipamento!");

    const response = await this.repository.getAllInspecaoMaquinasEquipItem(
      idControleCentroCusto,
      idInspecaoMaquinaEquip,
      page,
      rowsPerPage,
    );

    this._items = response.items;
    this._totalPages = response.totalPages;
    this._totalItems = response.totalItems;
    this._currentPage = response.currentPage;
    this._pageSize = response.pageSize;
  }
}
